import React from 'react';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-white py-4 md:py-6 px-4" data-id="element-46">
      <div className="max-w-4xl mx-auto text-center" data-id="element-47">
        <p className="text-sm md:text-base text-gray-500 mb-1" data-id="element-48">
          🚗 Para personas que quieren cuidar su auto sin ser mecánicos
        </p>

        <h1 className="text-2xl md:text-4xl font-black text-gray-900 mb-2 leading-tight" data-id="element-49">
          🔧 MegaPack Mecánica Preventiva para{' '}
          <span className="text-red-600" data-id="element-50">No Mecánicos</span>
        </h1>

        <a href="#pricing" className="block mb-2" data-id="element-51">
          <img src="https://cdn.magicpatterns.com/uploads/ePRyGJ2D4R8LAqz3CBCnPf/Diseno_sin_titulo_(7).png" alt="MegaPack Mecánica Preventiva Bundle" className="mx-auto w-full max-w-sm md:max-w-md drop-shadow-xl" data-id="element-52" />
        </a>

        <p className="text-base md:text-lg text-gray-700 mb-4 max-w-2xl mx-auto" data-id="element-53">
          Todo lo que necesitás para cuidar tu vehículo, evitar gastos
          innecesarios y no volver a sentirte perdido en un taller.
          <span className="block mt-1 font-bold text-gray-900" data-id="element-54">
            Claro, práctico y listo para usar. Sin tecnicismos. Sin vueltas.
          </span>
        </p>

        <div className="flex flex-col items-center gap-2" data-id="element-55">
          <Button variant="primary" fullWidth className="max-w-sm text-lg md:text-xl py-4" data-id="element-56">
            👉 SÍ, QUIERO ACCEDER AHORA
          </Button>

          <div className="flex items-center gap-2 text-gray-500 text-sm" data-id="element-57">
            <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-58" />✅ Garantía de
            satisfacción de 7 días
          </div>
        </div>
      </div>
    </section>;
}